/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentPolicySelector,
  AgentPolicySelector$inboundSchema,
} from "./agentpolicyselector.js";

export type AgentDelegatedGrant = {
  scope: string;
  /**
   * A constraint that narrows which resources an agent grant applies to.
   */
  selector: AgentPolicySelector;
};

/** @internal */
export const AgentDelegatedGrant$inboundSchema: z.ZodMiniType<
  AgentDelegatedGrant,
  unknown
> = z.object({
  scope: z.string(),
  selector: AgentPolicySelector$inboundSchema,
});

export function agentDelegatedGrantFromJSON(
  jsonString: string,
): SafeParseResult<AgentDelegatedGrant, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentDelegatedGrant$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentDelegatedGrant' from JSON`,
  );
}
